import {
  FiHome,
  FiUsers,
  FiCalendar,
  FiFileText,
} from "react-icons/fi";
import { BiUserCircle } from "react-icons/bi";
import { TbHotelService } from "react-icons/tb";
import { MdOutlineRateReview } from "react-icons/md";
import {
  AiOutlineUserAdd,
  AiOutlineFieldTime,
  AiOutlineSetting,
} from "react-icons/ai";
import { PiListStarFill } from "react-icons/pi";
import { FaFileInvoice } from "react-icons/fa";

const gearIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 128 128"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0,128) scale(0.1,-0.1)"
      fill="currentColor"
      stroke="none"
    >
      <path d="M552 1243 c-6 -10 -17 -45 -27 -78 -16 -58 -18 -61 -68 -81 l-52 -20 -73 35 -72 36 -57 -58 -58 -57 36 -72 35 -73 -20 -53 -21 -53 -75 -23 -75 -23 0 -84 0 -84 75 -24 75 -23 21 -54 21 -54 -36 -70 -36 -70 57 -57 58 -58 72 36 73 35 51 -20 c51 -20 51 -20 76 -95 l24 -76 84 0 84 0 24 75 c25 76 25 76 77 96 l52 21 64 -33 c35 -18 71 -33 79 -34 21 0 110 91 110 113 0 9 -15 44 -34 77 l-33 61 21 54 21 55 75 23 75 23 0 84 0 83 -75 23 -75 23 -21 53 -22 53 36 72 37 73 -58 57 -57 58 -72 -36 -73 -35 -53 20 -53 21 -23 75 -22 75 -82 3 c-69 2 -82 0 -90 -15z m165 -99 l23 -70 70 -28 70 -27 68 36 67 35 37 -38 38 -37 -35 -67 -36 -68 27 -70 28 -70 70 -23 71 -24 0 -53 0 -53 -71 -24 -70 -23 -28 -70 -27 -70 36 -68 35 -67 -38 -37 -37 -38 -67 35 -68 36 -70 -28 -71 -27 -22 -74 -21 -73 -55 3 -54 3 -24 71 -23 70 -70 28 -70 27 -68 -36 -67 -35 -37 38 -38 37 35 67 36 68 -27 70 -28 70 -70 23 -71 24 -3 55 -3 55 76 22 c41 13 75 27 75 33 0 6 12 36 26 68 l26 57 -36 70 -35 70 39 38 39 38 67 -37 67 -37 42 20 c24 11 55 23 69 27 22 5 29 17 48 81 l21 74 55 -3 55 -3 24 -71z" />
      <path d="M566 971 c-65 -43 -86 -132 -46 -198 51 -85 189 -85 240 0 58 95 -10 217 -120 217 -27 0 -56 -8 -74 -19z m145 -50 c64 -65 20 -171 -71 -171 -58 0 -100 42 -100 100 0 91 106 135 171 71z" />
      <path d="M473 656 c-52 -17 -109 -52 -117 -72 -10 -26 -5 -86 12 -149 l17 -60 257 -3 257 -2 10 37 c30 108 34 152 16 179 -22 34 -111 74 -179 81 l-53 6 -23 -42 c-13 -22 -27 -41 -30 -41 -3 0 -16 18 -29 40 -20 36 -26 40 -59 39 -20 0 -56 -6 -79 -13z m124 -78 c15 -29 35 -53 43 -53 8 0 28 24 44 54 l29 53 42 -4 c52 -6 114 -36 130 -63 10 -16 9 -34 -3 -87 l-15 -68 -227 0 -228 0 -12 53 c-6 28 -13 60 -15 70 -8 41 77 95 152 96 28 1 35 -5 60 -51z" />
    </g>
  </svg>
);

const mismatchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path d="M394 1241 c-52 -24 -99 -81 -114 -140 -7 -25 -14 -84 -15 -131 0 -47 -7 -95 -13 -107 -30 -55 7 -123 68 -123 16 0 30 -4 30 -9 0 -4 16 -23 35 -42 48 -47 46 -72 -5 -88 -22 -7 -45 -9 -50 -6 -18 11 -102 -17 -107 -36 -3 -10 -14 -21 -24 -24 -31 -10 -89 -86 -104 -139 -17 -56 -20 -202 -5 -211 6 -3 10 -42 10 -86 0 -72 2 -79 20 -79 18 0 20 7 20 80 l0 80 64 0 63 0 -8 -47 c-21 -120 -21 -113 0 -113 21 0 21 -2 44 140 l13 75 179 3 178 2 -56 -59 c-65 -67 -72 -97 -32 -136 39 -39 69 -32 135 31 63 60 61 61 75 -19 5 -29 10 -37 27 -37 16 0 19 5 14 23 -3 13 -8 49 -12 80 l-7 57 62 0 61 0 0 -80 c0 -73 2 -80 20 -80 18 0 20 7 20 79 0 44 5 83 10 86 6 3 10 39 10 79 l0 73 51 5 c83 8 139 63 147 147 6 69 -15 78 -66 28 -32 -32 -41 -35 -67 -29 -20 6 -31 17 -37 37 -6 26 -3 35 29 67 44 45 40 68 -12 68 -20 0 -50 -6 -68 -14 -36 -14 -87 -69 -87 -92 0 -21 -27 -17 -32 4 -6 20 -90 48 -108 37 -5 -3 -28 -1 -50 6 -51 16 -53 41 -5 88 19 19 35 38 35 42 0 5 14 9 30 9 61 0 98 68 68 123 -7 12 -13 60 -14 107 -2 108 -18 168 -57 215 -48 59 -94 75 -217 75 -81 0 -114 -5 -146 -19z m263 -32 c64 -24 122 -115 111 -175 -3 -18 -6 -19 -65 -6 l-62 14 -3 46 -3 47 -95 0 -95 0 -3 -47 -3 -46 -62 -14 c-59 -13 -62 -13 -65 6 -10 57 42 145 103 172 36 16 202 18 242 3z m-57 -139 l0 -30 -60 0 -60 0 0 30 0 30 60 0 60 0 0 -30z m135 -89 c29 -12 30 -13 10 -27 -13 -11 -31 -13 -55 -9 -86 15 -185 17 -254 6 -57 -9 -80 -9 -97 -1 -28 15 -15 28 42 40 60 12 317 6 354 -9z m-410 -71 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m326 -1 l69 -12 0 -46 c0 -90 -64 -171 -146 -187 -112 -21 -214 68 -214 187 l0 47 58 10 c81 14 152 14 233 1z m119 1 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-448 -87 c6 -45 3 -51 -20 -37 -22 14 -27 41 -12 59 19 23 27 18 32 -22z m472 14 c13 -21 -2 -50 -29 -56 -13 -2 -16 1 -11 14 3 9 6 28 6 42 0 27 17 27 34 0z m-174 -223 c0 -13 -67 -84 -80 -84 -13 0 -80 71 -80 84 0 7 29 11 80 11 51 0 80 -4 80 -11z m386 -23 c-27 -28 -28 -30 -14 -77 13 -46 16 -49 62 -62 47 -14 49 -13 78 15 l30 28 -7 -25 c-4 -14 -20 -38 -36 -55 -26 -26 -37 -30 -84 -30 l-54 0 -164 -163 c-90 -89 -170 -162 -178 -162 -19 0 -39 20 -39 39 0 8 73 88 162 178 l163 164 0 53 c0 44 5 60 25 81 23 25 53 43 74 44 6 1 -3 -12 -18 -28z m-533 -59 l36 -37 -22 -29 -23 -29 -32 56 c-18 31 -32 61 -32 67 0 22 38 8 73 -28z m207 28 c0 -6 -14 -36 -32 -67 l-32 -56 -23 29 -22 29 36 37 c35 36 73 50 73 28z m-341 -135 c36 -146 36 -145 13 -145 -14 0 -24 24 -50 124 -38 145 -38 146 -13 146 15 0 24 -21 50 -125z m76 16 c33 -66 43 -70 77 -32 l28 31 0 -80 0 -80 -53 0 -53 0 -29 118 c-40 166 -40 161 -16 125 11 -18 32 -55 46 -82z m283 -30 l-32 -131 -53 0 -53 0 0 80 0 80 28 -31 c16 -18 34 -29 40 -25 6 3 30 42 53 86 24 44 44 78 46 76 2 -2 -11 -62 -29 -135z m112 127 c0 -37 -56 -216 -73 -235 -11 -13 -22 -21 -25 -18 -2 2 10 63 28 135 27 109 35 130 51 130 11 0 19 -5 19 -12z m-547 -145 c20 -79 25 -116 19 -138 -8 -30 -9 -30 -85 -33 l-77 -3 0 63 c0 35 5 79 10 99 11 39 74 119 94 119 7 0 23 -43 39 -107z m616 85 c7 -19 3 -29 -22 -55 -17 -18 -33 -31 -35 -28 -2 2 2 27 9 54 14 54 34 66 48 29z m81 -213 l0 -45 -47 0 -47 0 44 45 c24 25 45 45 47 45 2 0 3 -20 3 -45z" />
    </g>
  </svg>
);

export const SIDEBAR_SECTIONS = {
  APPS: "apps",
  PINNED: "pinned",
  PRODUCTS: "products",
  REPORTS: "reports",
  ACTIONS: "actions",
};

export const getSidebarNavConfig = ({ canAccessFsr }) => ({
  standalone: [
    {
      id: "dashboard",
      label: "Dashboard",
      path: "/dashboard",
      pathMatch: "dashboard",
      icon: <FiHome />,
    },
  ],
  sections: [
  {
    id: SIDEBAR_SECTIONS.APPS,
    label: "Apps & Pages",
    collapsible: true,
    defaultOpen: true,
    items: [{
        id: "appointments",
        label: "Appointments",
        path: "/appointment",
        pathMatch: "appointment",
        icon: <FiCalendar />,
      },
      {
        id: "crm",
        label: "CRM",
        path: "/crm",
        pathMatch: "crm",
        icon: <FiUsers />,
      },
      {
        id: "fsr",
        label: "FSR",
        path: "/fsr",
        pathMatch: "fsr",
        icon: <FiUsers />,
        visible: canAccessFsr,
      },
      {
        id: "technician",
        label: "Technician",
        path: "/technician",
        pathMatch: "technician",
        icon: <BiUserCircle />,
      },
    ],
  },
  {
    id: SIDEBAR_SECTIONS.PRODUCTS,
    label: "Products and Services",
    collapsible: true,
    defaultOpen: false,
    items: [
      {
        id: "services",
        label: "All Services",
        path: "/services",
        pathMatch: "services",
        icon: <TbHotelService />,
      },
      {
        id: "addon",
        label: "Add-ons",
        path: "/addon",
        pathMatch: "addon",
        icon: <AiOutlineUserAdd />,
      },
      {
        id: "pricing",
        label: "Pricing",
        path: "/pricing",
        pathMatch: "pricing",
        icon: gearIcon,
      },
    ],
  },
  {
    id: SIDEBAR_SECTIONS.REPORTS,
    label: "Reports",
    collapsible: true,
    defaultOpen: false,
    items: [
      {
        id: "booking-report",
        label: "Booking Reports",
        path: "/booking-report",
        pathMatch: "booking-report",
        icon: <MdOutlineRateReview />,
      },
      {
        id: "callout-report",
        label: "Call Out Reports",
        path: "/callout-report",
        pathMatch: "callout-report",
        icon: <MdOutlineRateReview />,
      },
      {
        id: "cleaning-frequency-report",
        label: "Cleaning Frequency",
        path: "/cleaning-frequency-report",
        pathMatch: "cleaning-frequency-report",
        icon: <FaFileInvoice />,
      },
      {
        id: "booking-source-report",
        label: "Booking Source Report",
        path: "/booking-source-report",
        pathMatch: "booking-source-report",
        icon: <FaFileInvoice />,
      },
      {
        id: "getduplidatedata",
        label: "Get Duplicate Data",
        path: "/getduplidatedata",
        pathMatch: "getduplidatedata",
        icon: gearIcon,
      },
      {
        id: "getmismatchkeapid",
        label: "Get Mismatch Keap",
        path: "/getmismatchkeapid",
        pathMatch: "getmismatchkeapid",
        icon: gearIcon,
      },
      {
        id: "invoice-report",
        label: "Invoice Report",
        path: "/invoice-report",
        pathMatch: "invoice-report",
        icon: <FaFileInvoice />,
      },
      {
        id: "inactive-customer-report",
        label: "Inactive Customers",
        path: "/inactive-customer-report",
        pathMatch: "inactive-customer-report",
        icon: <FaFileInvoice />,
      },
      {
        id: "getreport",
        label: "Get Report",
        path: "/getreport",
        pathMatch: "getreport",
        icon: <FiFileText />,
      },
      {
        id: "getmissingappointment",
        label: "Get Missing Appointment",
        path: "/getmissingappointment",
        pathMatch: "getmissingappointment",
        icon: mismatchIcon,
      },
      {
        id: "gettechapps",
        label: "Get Tech Apps",
        path: "/gettechapps",
        pathMatch: "gettechapps",
        icon: mismatchIcon,
      }
    ],
  },
  {
    id: SIDEBAR_SECTIONS.ACTIONS,
    label: "Actions",
    collapsible: true,
    defaultOpen: false,
    items: [
      {
        id: "offtimerequest",
        label: "Time Off Request",
        path: "/offtimerequest",
        pathMatch: "offtimerequest",
        icon: <AiOutlineUserAdd />,
      },
      {
        id: "timesheet",
        label: "Timesheet",
        path: "/timesheet",
        pathMatch: "timesheet",
        icon: <AiOutlineFieldTime />,
      },
      {
        id: "getreviews",
        label: "Reviews",
        path: "/getreviews",
        pathMatch: "getreviews",
        icon: <PiListStarFill />,
      },
      {
        id: "keapsyncform",
        label: "Keap Sync",
        path: "/keapsyncform",
        pathMatch: "keapsyncform",
        icon: <FiUsers />,
      },
      {
        id: "email-builder",
        label: "Email Builder",
        path: "/email-builder",
        pathMatch: "email-builder",
        icon: <FaFileInvoice />,
      },
      {
        id: "setting",
        label: "Settings",
        path: "/setting",
        pathMatch: "setting",
        icon: <AiOutlineSetting />,
      },
      {
        id: "getstaxdata",
        label: "Get Stax Data",
        path: "/getstaxdata",
        pathMatch: "getstaxdata",
        icon: gearIcon,
      }
    ],
  },
  ],
});

export const flattenNavItems = (navConfig) => {
  const items = [];
  const sections = navConfig.sections || navConfig;
  const standalone = navConfig.standalone || [];

  standalone.forEach((item) => {
    if (item.visible !== false) items.push({ ...item, sectionId: "standalone" });
  });

  sections.forEach((section) => {
    section.items.forEach((item) => {
      if (item.visible === false) return;
      items.push({ ...item, sectionId: section.id });
    });
  });
  return items;
};
